import { Component, OnInit } from '@angular/core';
import { FinancieraService } from '../../../services/financiera-service';
import { TableDataSource } from '../../../utils/table-data-source';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DialogsService } from '../../../services/dialogs-service';
import { MdSnackBar } from '@angular/material';
import {Observable} from 'rxjs/Observable';
import * as moment from 'moment';

@Component({
  selector: 'app-entidades-financieras',
  templateUrl: './entidades-financieras.component.html',
  styleUrls: ['./entidades-financieras.component.scss']
})
export class EntidadesFinancierasComponent implements OnInit {

  entidades = [];

  loading = true;

  constructor(private financieraService: FinancieraService,
              private dialogsService: DialogsService,
              private snackBar: MdSnackBar) {
    financieraService.Options.subscribe(x => {
      // guardaamos el ID de la entidad abierta
      let open = -1;
      if (this.entidades.length) {
        // verificamos via index si hay alguna entidad abierta
        open = this.entidades.findIndex(y => y.open);
        // si la hay, transcribimos el ID
        if (open !== -1) {
          open = this.entidades[this.entidades.findIndex(y => y.open)].ID;
        }
      }
      this.entidades = x;
      this.entidades.forEach((ent, i) => {
        ent.FechaCreacion = `${moment.unix(ent.FechaCreacion).format('DD/MM/YY HH.mm')}hs`;
        ent['open'] = open !== -1 ? open === ent.ID : false;
        ent.Subentidades.forEach(sub => {
          sub.FechaCreacion = `${moment.unix(sub.FechaCreacion).format('DD/MM/YY HH.mm')}hs`;
        });
      });
      this.loading = false;
    });
    financieraService.loadOptions();
    this.loading = true;
  }

  ngOnInit() {}

  showNewEntidadDialog() {
    this.dialogsService.showNewEditEntidadDialog(this.getCodigos()).subscribe(res => {
      if (res) {
        this.financieraService.loadOptions();
      }
    });
  }

  showEditEntidadDialog(entidad) {
    this.dialogsService.showNewEditEntidadDialog(this.getCodigos(), entidad).subscribe(res => {
      if (res) {
        this.financieraService.loadOptions();
      }
    });
  }

  toggleSubentidadVisibility(subentidad) {
    const str = subentidad.Visibilidad ? 'ocultar' : 'mostrar';
    this.dialogsService.confirm(`¿Está seguro que desea ${str} este subtipo?`, null, `Sí, ${str.charAt(0).toUpperCase() + str.slice(1)}`, 'No, Cancelar').subscribe(res => {
      if (res) {
        this.financieraService.toggleEntidadVisibilidad(subentidad.ID).subscribe(x => {
          if (x) {
            this.financieraService.loadOptions();
          }
        }, err => {
          this.snackBar.open('Ha ocurrido un error procesando la solicitud. Por favor, intente nuevamente.', '', {
            duration: 2000,
            extraClasses: ['agd-warning-snackbar']
          });
        });
      }
    });
  }

  toggleExpand(ent) {
    if (!ent.open) {
      this.entidades.forEach(x => {
        if (x.ID !== ent.ID) {
          x.open = false;
        }
      });
    }
    ent.open = !ent.open;
  }

  getCodigos() {
    const codigos = [];
    this.entidades.forEach(x => {
      x.Subentidades.forEach(y => {
        codigos.push(y.Codigo);
      });
    });
    return codigos;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/entidades-financieras/entidades-financieras.component.ts